import * as React from 'react';
import YouTube from 'react-youtube';

export default function VideoPlayer(props) {
  const PLAYER_DEFAULT_OPTIONS = {
    height: '390',
    width: '100%',
    host: 'https://www.youtube-nocookie.com',
    playerVars: {
      autoplay: 0,
      start: 0,
    },
  };

  const {
    config = {},
    threshold = 30,
    completeSetter,
    buttonClicked
  } = props;
  const {video_id: videoId, timestamp = null} = config;

  const [player, setPlayer] = React.useState(null);
  const [playedSeconds, setPlayedSeconds] = React.useState(0);
  const [playerState, setPlayerState] = React.useState(-1); // YT.PlayerState.PLAYING
  const [watched, setWatched] = React.useState(false);

  const onReady = (evt) => setPlayer(evt.target);
  const onStateChange = (evt) => setPlayerState(evt.data);

  const intervalCallback = () => {
    if (player && playerState === YT.PlayerState.PLAYING) {
      setPlayedSeconds(prev => prev + 1);
    }
  };

  React.useEffect(() => {
    const interval = setInterval(intervalCallback, 1000);

    return () => clearInterval(interval);
  }, [player, playerState]);

  React.useEffect(() => {
    if (watched) {
      return;
    }

    if (watched === false && playedSeconds > threshold) {
      completeSetter(true)
      setWatched(true);
    }
  }, [playedSeconds]);

  React.useEffect(() => {
    if (player && buttonClicked) {
      try {
        player.pauseVideo();
      } catch (error) {
        console.log(`[Pathway] Failed to pause video; Reason: ${error.message}`);
      }
    }
  }, [buttonClicked]);

  if (timestamp) {
    PLAYER_DEFAULT_OPTIONS.playerVars.start = timestamp;
  }

  return (
    <div className='nv-video-player'>
      <YouTube videoId={videoId} opts={PLAYER_DEFAULT_OPTIONS} onReady={onReady} onStateChange={onStateChange}/>
    </div>
  );
}
